const $win = $(window);
const $body = $('body');

/**
 * Calculate the wrapper top offset, to compensate to header overlap
 * @return {Void}
 */
export const calcWrapperOffset = () => {
  const $header = $('.js-header');
  let offset = $header.height();

  if ($body.hasClass('template-page--shogun.default') || $body.hasClass('template-page--shogun-heritage') || $body.hasClass('template-page--shogun-shoe-care') || $body.hasClass('template-page--shogun-james')) {
    offset -= $('.js-header-nav-secondary').outerHeight();
  }

  $('.js-wrapper').css('padding-top', `${offset}px`);
};

calcWrapperOffset();

$win.on('resize orientationchange', function (event) {
  calcWrapperOffset();
});

$('.js-header').on('transitionend webkitTransitionEnd oTransitionEnd', function () {
  if ($win.scrollTop() == 0) {
    calcWrapperOffset();
  }
});
